import type { CoincidentAggregation } from '@ardoq/xyz-charts';

/**
 * Whether coincident components may be reduced by an aggregation. A list plotted as height allows
 * no sum: positions in a list have an order and no magnitude, so adding them names no value.
 */
export const isAggregationOffered = (
  aggregation: CoincidentAggregation,
  isListHeight: boolean
): boolean => !isListHeight || aggregation !== 'sum';

/** The aggregation to draw with: the setting where it is offered, the average where it is not. */
export const toListAggregation = (
  aggregation: CoincidentAggregation,
  isListHeight: boolean
): CoincidentAggregation =>
  isAggregationOffered(aggregation, isListHeight) ? aggregation : 'mean';
